import { render, staticRenderFns } from "./student_class.vue?vue&type=template&id=2fe29eaf&"
import script from "./student_class.vue?vue&type=script&lang=js&"
export * from "./student_class.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports